import { Container, Box, Typography } from "@mui/material";
import { useRouteError } from "react-router-dom";
import NavigationBar from "../pages/NavigationBar";

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <>
      <NavigationBar />
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mt: 4,
            gap: 2
          }}
        >
          <Typography variant="h2" component="h1">
            Oops!
          </Typography>
          <Typography variant="h5">
            Sorry, an unexpected error has occurred.
          </Typography>
          <Typography variant="body1" color="text.secondary" fontStyle="italic">
            {error.statusText || error.message}
          </Typography>
        </Box>
      </Container>
    </>
  );
}